import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customTextSizes = [
  'title-01',
  'heading-01',
  'heading-02-bold',
  'heading-02-semi',
  'heading-03',
  'body-01-bold',
  'body-01-semi',
  'body-01-medium',
  'body-02-bold',
  'body-02-semi',
  'body-02-medium',
  'body-02-regular',
  'body-03-semi',
  'body-03-regular',
  'caption-01-semi',
  'caption-01-medium',
  'caption-01-regular',
  'caption-02-bold',
  'caption-02-regular',
  'caption-03-semi',
  'caption-03-medium',
]

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [...customTextSizes.map((size) => `text-${size}`)],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}
